<ion-card
  *mobxAutorun
  class="ion-no-margin ly-col ion-align-items-center ion-justify-content-between flex md-border"
>
  <ion-text color="dark" class="ion-margin-top">
    <h2 class="ion-no-margin">
      <ion-skeleton-text *ngIf="rankSubscription" style="width: 30px"> </ion-skeleton-text>
      <b *ngIf="!rankSubscription" class="ion-text-uppercase">
        {{
          userWithStats?.statistics?.order === 0
            ? ('notAvailableShortText' | translate)
            : userWithStats?.statistics?.order
        }}
      </b>
    </h2>
  </ion-text>
  <ion-text color="dark">
    <b>
      <ion-skeleton-text *ngIf="rankSubscription" style="width: 80px"> </ion-skeleton-text>
      <ng-container *ngIf="!rankSubscription">
        {{ 'workspace.dashboard.titles.yourRank' | translate }}
      </ng-container>
    </b>
  </ion-text>
  <ion-row class="ion-margin-top stretch-x">
    <ion-button class="ion-no-margin stretch-x" expand="full" [disabled]="true">
      <ion-icon name="bar-chart-outline" slot="start"> </ion-icon>
      {{ 'workspace.dashboard.buttons.viewPerformance' | translate }}
    </ion-button>
  </ion-row>
</ion-card>
